<script>
import TranslateModal from '@wielink-application/translation/vue/translation/translate-modal.vue'
export default TranslateModal;
</script>